<template>
  <div>
    <v-tooltip left>
      <v-btn small color="#00acc2" @click="openListForm()" slot="activator" fab>
        <v-icon color="#fff" medium>assignment</v-icon>
      </v-btn>
      <span>Lista de formulários</span>
    </v-tooltip>

    <v-dialog v-model="dialogFormList" persistent width="500" scrollable :fullscreen="$vuetify.breakpoint.smAndDown">
      <v-card>
        <v-card-title class="headline grey lighten-4 pa-3" primary-title>
          <v-icon color="teal" large>assignment</v-icon>
          <span class="headline pl-2"><strong>Lista de formulários</strong></span>
          <v-btn icon style="right: 0; position: absolute" slot="activator" fab @click="close">
            <v-icon color="black">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-list class="pa-0">
            <v-progress-linear v-if="showProgressBar" indeterminate ></v-progress-linear>
            <v-list-tile three-line v-else-if="forms.length === 0">
              Não possui formulários cadastrados
            </v-list-tile>
            <template v-else v-for="(item, index) in forms">
              <v-list-tile :key="index">
                <v-list-tile-content @click="openLink(item.id)">
                  <v-list-tile-title>
                    <a style="color: #02444d" target="_blank">{{ item.id_text }}</a>
                  </v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-tooltip left>
                    <v-btn slot="activator" icon class="mx-0">
                      <v-icon color="primary" @click="copyLink(item.id)">file_copy</v-icon>
                    </v-btn>
                    <span>Copiar link do formulário</span>
                  </v-tooltip>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider :key="'d'+index" v-if="index + 1 < forms.length"></v-divider>
            </template>
          </v-list>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <!-- <a href="https://illis.com.br/features/#formulario" target="_blank">Clique aqui</a>&nbsp;e aprenda a adicionar novos fomulários. -->
          <v-spacer></v-spacer>
          <v-btn flat @click="close">Sair</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    name: 'PFormList',
    data: () => ({
      forms: [],
      showProgressBar: false,
      dialogFormList: false
    }),
    methods: {
      openListForm () {
        this.dialogFormList = true
        this.showProgressBar = true
        this.$http.get(`api/form_list`).then((res) => {
          this.forms = res.body
          this.showProgressBar = false
        }, err => {
          console.log(err)
          this.showProgressBar = false
          this.$store.commit('snackbar/change_values', {text: 'Não foi possível carregar os registros dos formulários, reporte o erro.', color: 'error', dialog: true})
        })
      },
      link (formId) {
        return `https://${window.location.hostname}/#/form_view/${btoa(formId)}`
      },
      openLink (formId) {
        let link = this.link(formId)
        var win = window.open(link, '_blank')
        if (win) {
          win.focus()
        } else {
          alert('Favor habilitar so popups')
        }
      },
      copyLink (formId) {
        let text = this.link(formId)
        // caso não tenha a função de clipboard, usa outro metodo para pegar de acordo com a seleção
        if (!navigator.clipboard) {
          var textArea = document.createElement('textarea')
          textArea.value = text
          // Avoid scrolling to bottom
          textArea.style.top = '0'
          textArea.style.left = '0'
          textArea.style.position = 'fixed'
          document.body.appendChild(textArea)
          textArea.focus()
          textArea.select()
          try {
            var successful = document.execCommand('copy')
            if (successful) this.$store.commit('snackbar/change_values', { text: 'Link copiado com sucesso!', color: 'success', dialog: true })
          } catch (err) {
            console.error('Fallback: Oops, unable to copy', err)
          }
          document.body.removeChild(textArea)
          return
        }
        navigator.clipboard.writeText(text).then(() => {
          this.$store.commit('snackbar/change_values', { text: 'Link copiado com sucesso!', color: 'success', dialog: true })
        }, (err) => {
          console.error('Async: Could not copy text: ', err)
        })
      },
      close () {
        this.dialogFormList = false
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/shared/PFormList.vue